<template>
    <div v-if="assetType == 'otherTechnology'">
        <div v-if="benchlingId" class="round-action-icon" :class="{'bg-gray-300':isBEWULoading, 'bg-green-600': !isBEWULoading}" @click="!isBEWULoading && openBenchlingDetailPage()" title="open benchling detail page">
            <BenchlingIcon />
        </div>
        <div v-else class="round-action-icon" @click="openModal()" title="Propagate Asset to Benchling">
            <BenchlingIcon />
        </div>

        <ModalSlots v-if="!benchlingId" :show="isOpen" dialogClass="propagate-asset-modal" @close-modal="closeModal">
            <template v-slot:header><p>Propagate Asset to Benchling</p></template>
            <template v-slot:body>
                <LoaderPage v-if="propagationInProgress" loader-text="Propagating Asset to Benchling" gif-position="center"/>
                <div class="form-container m-4 mt-0"> 
                    <FormErrorToast :is-showing="!!propagationError" title="FAILED!" :subtitle="propagationError" toast-type="error" /> 
                    <p class="my-10">By continuing, a <span class="font-bold">{{nickname}}</span> entry will be automatically created in Benchling. </p>
                </div>
            </template>
            <template v-slot:footer>
                <button class="button cancel" @click="closeModal">cancel</button>
                <button class="button green-accept" @click="handlePropagation">Continue</button>
            </template>
        </ModalSlots>
    </div>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import ModalSlots from "@/components/ModalSlots.vue";
import FormErrorToast from '@/components/FormErrorToast.vue';
import LoaderPage from "./LoaderPage.vue";
import { useMutation, useQuery } from "@vue/apollo-composable";
import {OTHER_TECHNOLOGY_PROPAGATE} from "@/grapql/benchlingMutations";
import { GET_BENCHLING_ENTITY_WEB_URL } from "@/grapql/benchlingQueries";
import { POSITION, useToast } from 'vue-toastification';
import BenchlingIcon from "@/components/icons/BenchlingIcon.vue";

const toast = useToast();
const store = useStore();
const assetType = computed(() => store.getters["assetDetailModule/getAssetType"]);

const assetId = computed(() => store.getters["assetDetailModule/getAssetValues"].id);
const benchlingId  = computed(()=> store.getters["assetDetailModule/getAssetValues"].benchlingId);
const nickname = computed(() => store.getters["assetDetailModule/getAssetValues"].nickname);

const isOpen = ref(false);
const closeModal = () => { isOpen.value = false;}

const propagationError = ref(null);
const propagationInProgress = ref(false)
const openModal = () => {
    propagationError.value = null;
    propagationInProgress.value = false;
    isOpen.value = true; 
}

const handlePropagation = async () =>{
    propagationInProgress.value = true;
    propagationError.value = null;

    const { mutate: propagate, onDone, onError } = useMutation(OTHER_TECHNOLOGY_PROPAGATE);
    propagate({input: {"id": assetId.value}});
    onDone( async (result) => {
        if (result.data && result.data.otherTechnologyBenchlingPropagate.benchlingId) {
            store.commit('assetDetailModule/setOtherTechnologyBenchlingId', {benchlingId: result.data.otherTechnologyBenchlingPropagate.benchlingId});
            toast.success(`Asset Propagated Successfully`, { position: POSITION.BOTTOM_LEFT, timeout: 3000 });
            closeModal();
        }
        else{
            propagationError.value = "Failed to propagate asset to Benchling";
        }
        propagationInProgress.value = false;
        
    });
    onError( async (error) => {
        propagationInProgress.value = false;
        propagationError.value= error.message;
    })
}

// Open Benchling Detail Page
const isBEWULoading = ref(false);
const openBenchlingDetailPage = async () =>{
    isBEWULoading.value = true;

    const { onResult, onError } = useQuery(GET_BENCHLING_ENTITY_WEB_URL, {entityId:benchlingId}, {fetchPolicy: 'cache-and-network'});
    
    onResult(async queryResult => {

        if (queryResult.data && queryResult?.data.getBenchlingEntityWebUrl) {
            const benchlingUrl = queryResult.data.getBenchlingEntityWebUrl;
            console.log("Benchling URL: ", benchlingUrl);
            window.open(benchlingUrl, '_blank');
            isBEWULoading.value = false;
        }
    })
    onError(async error => {
        toast.error(error.message, { position: POSITION.BOTTOM_LEFT, timeout: 3000 });
        isBEWULoading.value = false;
    })

}
</script>